import darkDesktop from 'img/familyTariffModal/desktop/familyTariffDark.jpg';
import lightDesktop from 'img/familyTariffModal/desktop/familyTariffLight.jpg';
import darkMobile from 'img/familyTariffModal/mobile/familyTariffDark.png';
import lightMobile from 'img/familyTariffModal/mobile/familyTariffLight.png';
import React from 'react';
import styles from 'reactApp/ui/FamilyTariffModal/FamilyTariffModal.css';

export const FAMILY_TARIFF_CONTENT_MAP = {
    title: 'Готово! Вы подключили семейную подписку Mail Space',
    textDesktop: (
        <>
            Теперь добавьте участников. Это{'\u00A0'}можно сделать
            <br />
            сейчас или{'\u00A0'}позже в{'\u00A0'}разделе <span className={styles.boldText}>Управлять подпиской</span>
        </>
    ),
    textMobile: (
        <>
            Теперь добавьте участников. Это{'\u00A0'}можно
            <br />
            сделать сейчас или{'\u00A0'}позже в{'\u00A0'}профиле
        </>
    ),
    primaryActionText: 'Добавить участников',
    secondaryActionText: 'Позже',
    lightImageUrls: {
        desktop: lightDesktop,
        mobile: lightMobile,
    },
    darkImageUrls: {
        desktop: darkDesktop,
        mobile: darkMobile,
    },
};
